import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { layoutsActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { LayoutsService } from '../../services/layouts.service';

@Injectable({
  providedIn: 'root',
})
export class LayoutsEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private layoutsService: LayoutsService,
  ) {}

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(layoutsActions.findAll),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        return this.layoutsService.findAll().pipe(
          map((response) =>
            layoutsActions.findAllSuccess({
              layouts: response.data,
            }),
          ),
          catchError((error: ApiError) =>
            of(layoutsActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
